import React from "react";
import PropTypes from "prop-types";

import TechnologySectionBlock from "./technology-section-block";
import {
  PageWrap,
  Content,
  NoteBlock,
  NoteHeading,
  NoteBody,
  NoteList,
} from "./styles";

const TechnologyPageContent = ({ technology }) => {
  const advantages = technology.advantages;
  const note = technology.note;

  return (
    <PageWrap name="technology" as="section">
      <Content>
        <TechnologySectionBlock
          technology={technology}
          titleAs="h1"
          ctaMode="contact"
        />

        {advantages?.items?.length > 0 ? (
          <NoteBlock aria-labelledby="tech-advantages-heading">
            <NoteHeading id="tech-advantages-heading">
              {advantages.title}
            </NoteHeading>
            <NoteList>
              {advantages.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </NoteList>
          </NoteBlock>
        ) : null}

        {note ? (
          <NoteBlock aria-labelledby="tech-note-heading">
            <NoteHeading id="tech-note-heading">{note.title}</NoteHeading>
            <NoteBody>{note.body}</NoteBody>
          </NoteBlock>
        ) : null}
      </Content>
    </PageWrap>
  );
};

TechnologyPageContent.propTypes = {
  technology: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    navLabel: PropTypes.string,
    advantages: PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
    note: PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default TechnologyPageContent;
